<script>
	import Helper from '../Classes/Helper';
	import Layout from '../Stores/Layout';
	import Menu from '../Stores/Menu';
	import Next from '../Stores/Next';
	import Product from '../Stores/Product';

	let quotation_order = 0;
	let quotation_active = false;
	let info_active = true;
	let config_active = false;

	function setQuotationOrder() {
		let order = 0;
		if ($Product.steps)
			for (let step of $Product.steps)
				order = step.order + 1;

		quotation_order = order;
	}

	function setStep(order, config) {
		setQuotationOrder();
		Next.setCancel();
		Product.setStep(order, config);
		if (order) Layout.product();
		$Menu.open = false;
	}

	function setInfo() {
		setStep(0);
		Layout.info();
	}

	function setConfig() {
		setStep(0);
		Layout.config();
	}

	function setQuotation() {
		setStep(0, {force_validation: true});
		Layout.quotation();
	}

	function setLayout(state) {
		info_active = state.type === 'info';
		quotation_active = state.type === 'quotation';
		config_active = state.type === 'config';
	}

	Layout.subscribe(state => {
		setLayout(state);
	});

	Product.subscribe(state => {
		if (state.steps)
			setQuotationOrder();
	});
</script>

<style>
	div.zes-steps {
		text-align: center;
		width: 22%;
		background-color: var(--zes-1-2);
	}

	div.zes-steps > div {
		padding: 1.25em .75em;
		cursor: pointer;
	}

	div.zes-steps > div:hover {
		background: var(--zes-1-1) !important;
	}

	div.zes-steps > div:first-child {
		padding-top: 3em;
	}

	div.zes-steps > div.zes-active {
		background: var(--zes-1-3) !important;
	}

	div.zes-steps > div.zes-success {
		background: var(--zes-2-1);
	}

	div.zes-steps > div.zes-error {
		background: var(--zes-4-2);
	}

	div.zes-steps > div:first-child {
		background: hsl(0deg 0% 0% / .5);
	}

	div.zes-steps > div.zes-separator {
		border-top: 1px solid hsla(0, 100%, 100%, .25);
	}

	div.zes-steps > div i {
		font-size: 1.75em;
		margin-bottom: .35em;
		color: hsl(0deg 100% 100%);
	}

	div.zes-steps > div div {
		font-size: .75em;
		font-weight: 700;
		text-transform: uppercase;
		color: hsl(0deg 100% 100%);
	}

	/* Responsive */

	@media only screen and (max-width: 1024px) and (orientation: portrait) {
		div.zes-steps > div:first-child {
			padding-top: 1.75em;
		}
	}
</style>

<div class="zes-steps zes-scroll">
	<div on:click="{event => setInfo()}" class:zes-active="{info_active}">
		<i class="fa-light fa-circle-info"></i>
		<div>Info</div>
	</div>
	{#if $Product.steps}
		{#each $Product.steps as step}
			<div on:click="{event => setStep(step.order)}" class="zes-{step.state}" class:zes-active="{step.active}">
				<i class="fa-light fa-circle-{step.order}"></i>
				<div>{step.name}</div>
			</div>
		{/each}
		<div on:click="{event => setQuotation()}" class:zes-active="{quotation_active}">
			<i class="fa-light fa-circle-{quotation_order}"></i>
			<div>Offerte</div>
		</div>
		{#if Helper.is($Product.render_texture)}
			<div on:click="{event => setConfig()}" class="zes-separator" class:zes-active="{config_active}">
				<i class="fa-light fa-paintbrush-pencil"></i>
				<div>Weergave</div>
			</div>
		{/if}
	{/if}
</div>